export default __webpack_public_path__ + "static/media/player-katie-colour-mob@2x.33b7b7b8.png";